import * as React from 'react';
import { renderText } from '../dateneingabe/assistent/assistent_helpers';

export interface NachhaltigkeitProps {
    data: any;
}

export class Nachhaltigkeit extends React.Component<NachhaltigkeitProps, {}> {

    constructor(props: any) {
        super(props);
        this.state = {};
    }

    render(): JSX.Element {
        return (
            <div style={{ padding: 20, maxWidth: 840, textAlign: 'justify', overflowY: 'auto', overflowX: 'hidden' }}>
                {renderText('Nachhaltigkeit', this.props.data)}
            </div>
        );
    }
}
